import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Textarea } from "@/components/ui/textarea"
import { GENERIC_FIELD_TYPES } from "@/lib/care-plan-form-utils"

export function FieldInspector({ field, onChange }) {
  if (!field) {
    return <p className="text-sm text-muted-foreground p-4">Selectează un câmp pentru proprietăți.</p>
  }
  const update = (patch) => onChange({ ...field, ...patch })
  return (
    <div className="space-y-3 p-4 border-l border-border">
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Proprietăți câmp</p>
      <div>
        <Label className="text-xs">Etichetă</Label>
        <Input className="mt-1 h-8" value={field.label || ""} onChange={(e) => update({ label: e.target.value })} />
      </div>
      <div>
        <Label className="text-xs">Tip</Label>
        <Select value={field.type || "text"} onValueChange={(v) => update({ type: v })}>
          <SelectTrigger className="mt-1 h-8"><SelectValue /></SelectTrigger>
          <SelectContent>
            {GENERIC_FIELD_TYPES.map((t) => (
              <SelectItem key={t.type} value={t.type}>{t.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <label className="flex items-center gap-2 text-sm">
        <input type="checkbox" checked={!!field.required} onChange={(e) => update({ required: e.target.checked })} />
        Obligatoriu
      </label>
      <div>
        <Label className="text-xs">Prefill (bind)</Label>
        <Input
          className="mt-1 h-8 font-mono text-xs"
          placeholder="client.name"
          value={field.bind || ""}
          onChange={(e) => update({ bind: e.target.value })}
        />
      </div>
      {(field.type === "select" || field.type === "multiselect") && (
        <div>
          <Label className="text-xs">Opțiuni (câte una pe linie)</Label>
          <Textarea
            className="mt-1 text-xs min-h-[80px]"
            value={(field.options || []).join("\n")}
            onChange={(e) =>
              update({ options: e.target.value.split("\n").map((s) => s.trim()).filter(Boolean) })
            }
          />
        </div>
      )}
      {field.type === "scale_score" && (
        <div>
          <Label className="text-xs">Scală</Label>
          <Input className="mt-1 h-8" value={field.scale || ""} onChange={(e) => update({ scale: e.target.value })} />
        </div>
      )}
    </div>
  )
}
